import type { StoreActionApi } from 'react-sweet-state';
import type { IssueAdjustmentsState } from '../../../types';
import type { ErrorCode } from '../../types';

/*
 * We need to persist the information that some errors happened to decide if success SLO event should be sent.
 * General UIM errors kept in `error` state property are reset after showing the flag.
 */
export const addBufferError =
	(errorCode: ErrorCode) =>
	({ setState, getState }: StoreActionApi<IssueAdjustmentsState>) => {
		const bufferErrors: ErrorCode[] = getState().bufferErrors || [];

		setState({
			bufferErrors: [...bufferErrors, errorCode],
		});
	};

export const resetBufferErrors =
	() =>
	({ setState }: StoreActionApi<IssueAdjustmentsState>) => {
		setState({
			bufferErrors: null,
		});
	};
